const INDIAN_MOBILE_REGEX = /^[6-9]\d{9}$/;

export function formatPhoneInput(value: string): string {
  return value.replace(/\D/g, "").slice(0, 10);
}

export function isValidIndianMobile(value: string): boolean {
  return INDIAN_MOBILE_REGEX.test(formatPhoneInput(value));
}
